(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brutech-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.brt-annbar').forEach(function (bar) {
    var speed     = parseInt(bar.dataset.speed, 10) || 5000;
    var pausing   = bar.dataset.pause === 'true';
    var sectionId = bar.dataset.sectionId || '';
    var closeDay  = parseInt(bar.dataset.closeDay, 10) || 3;
    var msgs      = Array.prototype.slice.call(bar.querySelectorAll('.brt-annbar__msg'));
    var pips      = Array.prototype.slice.call(bar.querySelectorAll('.brt-annbar__pip'));
    var counter   = bar.querySelector('.js-brt-ann-current');
    var prevBtn   = bar.querySelector('.brt-annbar__nav--prev');
    var nextBtn   = bar.querySelector('.brt-annbar__nav--next');
    var closeBtn  = bar.querySelector('.brt-annbar__close');
    var fill      = bar.querySelector('.brt-annbar__progress-fill');
    var current   = 0;
    var timer     = null;
    var paused    = false;

    if (!msgs.length) return;

    if (sectionId && sessionStorage.getItem('brt-ann-dismissed-' + sectionId)) {
      bar.classList.add('is-dismissed');
      return;
    }

    /* Loot Drop seal countdown. The vault seals at the end of closeDay,
       so find the next occurrence of that day and count down to midnight. */
    var sealEl = bar.querySelector('[data-loot-countdown]');
    if (sealEl) {
      var tick = function () {
        var now = new Date();
        var seal = new Date(now.getFullYear(), now.getMonth(), closeDay + 1, 0, 0, 0);
        if (seal <= now) seal = new Date(now.getFullYear(), now.getMonth() + 1, closeDay + 1, 0, 0, 0);
        var diff = seal - now;
        if (diff <= 0) { sealEl.textContent = 'Sealing'; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var left = d > 0 ? (d + 'd ' + h + 'h') : (h > 0 ? (h + 'h ' + m + 'm') : (m + 'm'));
        sealEl.innerHTML = 'Seals in <b>' + left + '</b>';
      };
      tick();
      setInterval(tick, 60000);
    }

    function show(idx) {
      msgs[current].classList.remove('is-active');
      if (pips[current]) pips[current].classList.remove('is-on');
      current = (idx + msgs.length) % msgs.length;
      msgs[current].classList.add('is-active');
      if (pips[current]) pips[current].classList.add('is-on');
      if (counter) counter.textContent = current + 1;
      resetProgress();
    }

    function resetProgress() {
      if (!fill) return;
      fill.classList.remove('is-running');
      void fill.offsetWidth;
      fill.classList.add('is-running');
    }

    function startAuto() {
      clearInterval(timer);
      if (msgs.length < 2) return;
      timer = setInterval(function () {
        if (!paused && !document.hidden) show(current + 1);
      }, speed);
    }

    function stopAuto() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); show(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); show(current + 1); startAuto(); });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.add('is-dismissed');
        stopAuto();
        if (sectionId) sessionStorage.setItem('brt-ann-dismissed-' + sectionId, '1');
      });
    }

    if (pausing) {
      bar.addEventListener('mouseenter', function () { paused = true;  if (fill) fill.classList.remove('is-running'); });
      bar.addEventListener('mouseleave', function () { paused = false; if (fill) fill.classList.add('is-running'); });
    }

    /* Pause while a keyboard user is inside the bar */
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });

    var touchX = null;
    bar.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    bar.addEventListener('touchend', function (e) {
      if (touchX === null || msgs.length < 2) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { stopAuto(); show(dx < 0 ? current + 1 : current - 1); startAuto(); }
      touchX = null;
    }, { passive: true });

    if (msgs.length > 1) {
      resetProgress();
      startAuto();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-landing-creator"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  const items = document.querySelectorAll('.bt-clp__faq-item');
  for (const item of items) {
    item.addEventListener('toggle', () => {
      if (item.open) {
        for (const other of items) { if (other !== item && other.open) other.removeAttribute('open'); }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-landing-game"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  const items = document.querySelectorAll('.bt-glp__faq-item');
  for (const item of items) {
    item.addEventListener('toggle', () => {
      if (item.open) {
        for (const other of items) {
          if (other !== item && other.open) other.removeAttribute('open');
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-lorgar-pc-promo"] && !Shopify.designMode) return;
  try {
    
  /* ══════════════════════════════════════════════════════════════
     This section looks after itself. It lifts its panel into the buy box,
     ticks, counts, and adds the ticked items to the cart together with the
     PC, whichever version of assets/brutech-lorgar-pc.js the page has.
     If the page script already lifted the panel (the newer copy does),
     this stays out of the way and the page script runs the whole thing.
     ══════════════════════════════════════════════════════════════ */
  (function () {
    'use strict';

    /* written in two pieces so Liquid does not read it as a variable */
    var DEFAULT_FMT = '{' + '{amount}}';
    var own = { el: null, per: true, note: '', fmt: DEFAULT_FMT, sumLine: null, busy: false };

    function $(s, c) { return (c || document).querySelector(s); }
    function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

    function formatMoney(cents, fmt) {
      var format = String(fmt || DEFAULT_FMT).replace(/<[^>]*>/g, '');
      var re = /\{\{\s*(\w+)\s*\}\}/;
      var m = format.match(re);
      if (!m) return String(cents / 100);
      function delim(n, precision, thousands, decimal) {
        n = (n / 100).toFixed(precision);
        var parts = n.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var out;
      switch (m[1]) {
        case 'amount_no_decimals': out = delim(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = delim(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = delim(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': out = delim(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = delim(cents, 0, ' ', '.'); break;
        case 'amount_with_apostrophe_separator': out = delim(cents, 2, "'", '.'); break;
        default: out = delim(cents, 2, ',', '.');
      }
      out = out.replace(/[.,]00$/, '');
      return format.replace(re, out);
    }
    function money(c) { return formatMoney(c, own.fmt); }

    function pageRoot() { return $('[data-lpc]'); }
    function pageForm() { return $('form[data-lpc-form]'); }

    function ticked() {
      var out = [];
      if (!own.el) return out;
      $$('[data-lpp-row]', own.el).forEach(function (row) {
        var c = $('[data-lpp-chk]', row);
        var vid = parseInt(row.getAttribute('data-vid'), 10);
        if (!c || !c.checked || c.disabled || !vid) return;
        out.push({ vid: vid, price: parseInt(row.getAttribute('data-price'), 10) || 0 });
      });
      return out;
    }
    function qtyNow() {
      var v = $('[data-lpc-qty-val]');
      var n = v ? parseInt(v.textContent, 10) : 0;
      if (!n) { var i = $('[data-lpc-qty-input]'); n = i ? parseInt(i.value, 10) : 1; }
      return n > 0 ? n : 1;
    }
    function sets() { return own.per ? qtyNow() : 1; }
    function gearCards() { return $$('[data-gear].is-picked'); }

    /* The button reads Equip this build + N items. The page script writes its own count
       (gear only), so the count is corrected whenever the text changes. */
    function baseLabel() {
      var b = $('[data-lpc-atc]');
      return (b && b.getAttribute('data-label')) || 'Equip this build';
    }
    function fixLabel(el) {
      if (!el || (!own.el && !el.__lppTouched)) return;
      var t = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.indexOf(baseLabel()) !== 0 && t.indexOf('Pre-order') !== 0) return;
      var base = t.replace(/\s\+\s\d+\sitems?$/, '');
      var extra = gearCards().length + ticked().length;
      var want = extra > 0 ? base + ' + ' + extra + (extra === 1 ? ' item' : ' items') : base;
      if (want !== t) { el.__lppTouched = true; el.textContent = want; }
    }

    function render() {
      if (!own.el) return;
      var t = ticked();
      var r = pageRoot();
      var worth = 0;
      t.forEach(function (p) { worth += p.price; });
      worth *= sets();

      var c = $('[data-lpp-count]', own.el);
      var w = $('[data-lpp-worth]', own.el);
      if (c) c.textContent = String(t.length);
      if (w) w.textContent = money(worth);
      if (r) { if (t.length) r.setAttribute('data-lpp-active', '1'); else r.removeAttribute('data-lpp-active'); }

      var list = $('[data-sum-list]');
      if (list && list.parentNode && !own.sumLine) {
        var pl = document.createElement('div');
        pl.className = 'lpc-total__line lpc-total__line--promo';
        pl.setAttribute('hidden', '');
        pl.innerHTML = '<span>Free gear <em></em></span><b></b>';
        list.parentNode.insertBefore(pl, list);
        own.sumLine = pl;
      }
      if (own.sumLine) {
        var pb = $('b', own.sumLine);
        var pn = $('em', own.sumLine);
        if (pb) pb.textContent = money(0);
        if (pn) pn.textContent = '(' + t.length + (sets() > 1 ? ' x ' + sets() : '') + ')';
        if (t.length > 0) own.sumLine.removeAttribute('hidden'); else own.sumLine.setAttribute('hidden', '');
      }
      fixLabel($('[data-lpc-atc]'));
      fixLabel($('[data-sum-add-label]'));
    }

    function release() {
      if (own.el && own.el.parentNode) own.el.parentNode.removeChild(own.el);
      if (own.sumLine && own.sumLine.parentNode) own.sumLine.parentNode.removeChild(own.sumLine);
      own.el = null;
      own.sumLine = null;
      var r = pageRoot();
      if (r) r.removeAttribute('data-lpp-active');
      $$('[data-lpp-own]').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      /* the button goes back to counting gear only */
      fixLabel($('[data-lpc-atc]'));
      fixLabel($('[data-sum-add-label]'));
    }

    function showFix(on) {
      var fix = $('[data-lpp-fix]');
      if (!fix) return;
      if (on) fix.removeAttribute('hidden'); else fix.setAttribute('hidden', '');
    }

    function ensure() {
      var r = pageRoot();
      if (!r) return;
      /* the page script lifted it already and owns the panel */
      if ($('[data-lpp-clone]:not([data-lpp-own])')) { release(); showFix(false); return; }

      var src = $('[data-lpp]:not([data-lpp-clone])');
      var anchor = $('.lpc-buy', r);
      if (!src) { release(); return; }
      if (!anchor || !anchor.parentNode) { showFix(true); return; }
      if (own.el && own.el.isConnected && own.el.nextElementSibling === anchor) { showFix(false); return; }

      release();
      var el = src.cloneNode(true);
      el.setAttribute('data-lpp-clone', '1');
      el.setAttribute('data-lpp-own', '1');
      el.setAttribute('data-lpp-ready', '1');
      anchor.parentNode.insertBefore(el, anchor);
      own.el = el;
      own.per = el.getAttribute('data-per-pc') !== 'false';
      own.note = el.getAttribute('data-note') || '';
      own.fmt = r.getAttribute('data-money') || el.getAttribute('data-money') || DEFAULT_FMT;
      $$('[data-lpp-chk]', el).forEach(function (c) {
        c.addEventListener('change', function () { say(''); render(); });
      });
      showFix(false);
      render();
    }

    /* ── add to cart ── */
    function say(text) { var m = $('[data-sum-msg]'); if (m) m.textContent = text || ''; }

    function busy(on) {
      own.busy = on;
      [$('[data-lpc-atc]'), $('[data-sum-add]')].forEach(function (b) {
        if (!b) return;
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
      var a = $('[data-lpc-atc]');
      var l = $('[data-sum-add-label]');
      if (on) {
        if (a) a.textContent = 'Adding...';
        if (l) l.textContent = 'Adding...';
      } else {
        if (a) a.textContent = baseLabel();
        if (l) l.textContent = baseLabel();
        fixLabel(a);
        fixLabel(l);
      }
    }

    function cartIsDrawer() {
      try { return window.themeVariables.settings.cartType === 'drawer'; } catch (e) { return false; }
    }

    function addAll() {
      if (own.busy) return;
      var r = pageRoot();
      var f = pageForm();
      var idEl = f ? $('[name="id"]', f) : null;
      var pcId = idEl ? parseInt(idEl.value, 10) : 0;
      if (!r || !pcId) return;

      var tag = r.getAttribute('data-pc-title') || 'LORGAR PC';
      var items = [{ id: pcId, quantity: qtyNow(), properties: { _loadout: tag } }];
      gearCards().forEach(function (card) {
        var sel = $('[data-gear-variant]', card);
        var vid = parseInt(sel ? sel.value : card.getAttribute('data-vid'), 10);
        if (vid) items.push({ id: vid, quantity: 1, properties: { _loadout: tag } });
      });
      var k = sets();
      ticked().forEach(function (p) {
        var props = { _loadout: tag, _promo: '1' };
        if (own.note) props.Promo = own.note;
        items.push({ id: p.vid, quantity: k, properties: props });
      });

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var wantDrawer = r.getAttribute('data-after-add') === 'drawer' && cartIsDrawer();
      var body = { items: items };
      if (wantDrawer) {
        var bundle = { sections: [] };
        try {
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: bundle }));
        } catch (e) { /* the drawer refreshes itself anyway */ }
        if (bundle.sections.length) {
          body.sections = bundle.sections.join(',');
          body.sections_url = rootUrl + 'variants/' + pcId;
        }
      }

      say('');
      busy(true);
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.text().then(function (txt) {
          var data = null;
          try { data = JSON.parse(txt); } catch (e) { data = null; }
          return { ok: res.ok, status: res.status, data: data };
        });
      }).then(function (res) {
        if (!res.ok) {
          busy(false);
          var d = res.data && (res.data.description || res.data.message);
          say(d ? String(d) : 'Could not add to the cart (error ' + res.status + '). Please try again.');
          return;
        }
        try { window.sessionStorage.removeItem('lpc:' + tag); } catch (e) { /* ignore */ }
        if (!wantDrawer) { window.location.href = rootUrl + 'cart'; return; }
        return fetch(rootUrl + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
          cart.sections = (res.data && res.data.sections) || {};
          var added = (res.data && res.data.items) || [];
          document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          busy(false);
          /* put the picked gear back, the same as pressing each one again */
          $$('[data-gear].is-picked [data-gear-pick]').forEach(function (b) { b.click(); });
        });
      }).catch(function () {
        busy(false);
        window.location.href = rootUrl + 'cart';
      });
    }

    /* These run before the page script's own handlers, and only while this
       section owns the panel and something free is ticked. */
    document.addEventListener('submit', function (e) {
      var t = e.target;
      if (!own.el || !t || !t.matches || !t.matches('form[data-lpc-form]')) return;
      if (ticked().length === 0) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addAll();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t || !own.el) return;
      if (t.closest('[data-sum-add]') && ticked().length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addAll();
        return;
      }
      if (t.closest('[data-lpc-qty], [data-gear-pick], [data-sum-clear]')) setTimeout(render, 0);
    }, true);
    document.addEventListener('change', function (e) {
      if (own.el && e.target && e.target.matches && e.target.matches('[data-gear-variant]')) setTimeout(render, 0);
    }, true);

    /* the page script rewrites the button text on its own events */
    function watch() {
      if (!window.MutationObserver) return;
      var mo = new MutationObserver(function () { fixLabel($('[data-lpc-atc]')); fixLabel($('[data-sum-add-label]')); });
      [$('[data-lpc-atc]'), $('[data-sum-add-label]')].forEach(function (n) {
        if (n && !n.__lppWatched) { n.__lppWatched = true; mo.observe(n, { childList: true, characterData: true, subtree: true }); }
      });
    }

    function later(ms) { setTimeout(function () { ensure(); watch(); render(); }, ms); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { later(700); });
    else later(700);
    window.addEventListener('load', function () { later(60); });
    document.addEventListener('pageshow', function () { later(60); });

    /* theme editor: a section was re-rendered or removed */
    document.addEventListener('shopify:section:load', function () { release(); later(500); });
    document.addEventListener('shopify:section:unload', function (e) {
      var id = e.detail && e.detail.sectionId;
      if (own.el && id && own.el.getAttribute('data-section-id') === String(id)) { release(); }
      showFix(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-order-tracker"] && !Shopify.designMode) return;
  try {
    

  class BrutechOrderTracker extends HTMLElement {

    /* Stage definitions — matches Shopify financial_status / fulfillment_status */
    static STAGES = [
      {
        id:     'received',
        name:   'Order Received',
        icon:   '📋',
        desc:   'Your order has been confirmed and payment processed.',
        detail: 'We\'ve received your order and it\'s been added to our build queue. You\'ll receive a confirmation email shortly.',
        time:   'Day 1'
      },
      {
        id:     'building',
        name:   'In Build',
        icon:   '🔧',
        desc:   'Your PC is being assembled by our technicians.',
        detail: 'Our team is building your custom PC, installing all components and cable managing your system.',
        time:   'Day 1–2'
      },
      {
        id:     'testing',
        name:   'Burn-in Testing',
        icon:   '⚡',
        desc:   'Your PC is undergoing rigorous stress testing and QA.',
        detail: 'We run Prime95, FurMark, and game benchmarks to ensure everything is stable and performing as expected.',
        time:   'Day 2–3'
      },
      {
        id:     'shipped',
        name:   'Dispatched',
        icon:   '🚀',
        desc:   'Your PC has been packed and handed to the courier.',
        detail: 'Your build is on its way. Check your email for a tracking number from our courier partner.',
        time:   'Day 4'
      },
      {
        id:     'delivered',
        name:   'Delivered',
        icon:   '✅',
        desc:   'Your loadout has been deployed. Time to play.',
        detail: 'Your PC has been delivered. Power it on and enter the game. Welcome to the Brutech family.',
        time:   'Day 5'
      }
    ];

    connectedCallback() {
      this._form    = this.querySelector('[data-lookup-form]');
      this._orderIn = this.querySelector('[data-order-input]');
      this._emailIn = this.querySelector('[data-email-input]');
      this._btn     = this.querySelector('[data-lookup-btn]');
      this._error   = this.querySelector('[data-error]');
      this._loading = this.querySelector('[data-loading]');
      this._card    = this.querySelector('[data-card]');

      this._btn.addEventListener('click', () => this._lookup());

      /* Auto-fill from URL params e.g. ?order=1234&email=a@b.com */
      const params = new URLSearchParams(window.location.search);
      if (params.get('order')) this._orderIn.value = params.get('order');
      if (params.get('email')) this._emailIn.value = params.get('email');
      if (params.get('order') && params.get('email')) this._lookup();
    }

    async _lookup() {
      const orderNum = this._orderIn.value.trim().replace('#','');
      const email    = this._emailIn.value.trim();

      if (!orderNum || !email) {
        this._showError('Please enter both your order number and email address.');
        return;
      }

      this._hideError();
      this._setLoading(true);
      this._card.classList.remove('visible');

      try {
        /* Shopify storefront order lookup — requires customer to be logged in
           OR we use the order status URL approach */
        const res = await fetch(`/account/orders/${orderNum}`, {
          headers: { 'Accept': 'application/json' }
        });

        if (!res.ok) throw new Error('not_found');

        const data = await res.json();
        this._renderOrder(data.order || data);

      } catch (err) {
        /* Fallback: show demo mode if order not found via API */
        if (err.message === 'not_found') {
          this._showError('Order not found. Please check your order number and email address match.');
        } else {
          /* Show demo for testing purposes */
          this._renderDemo(orderNum);
        }
      } finally {
        this._setLoading(false);
      }
    }

    _renderOrder(order) {
      /* Map Shopify statuses to our stage IDs */
      let stageId = 'received';
      const fin  = (order.financial_status || '').toLowerCase();
      const ful  = (order.fulfillment_status || '').toLowerCase();

      if (ful === 'fulfilled' || ful === 'delivered') stageId = 'delivered';
      else if (ful === 'in_transit' || ful === 'out_for_delivery') stageId = 'shipped';
      else if (ful === 'partial')  stageId = 'testing';
      else if (fin === 'paid')     stageId = 'building';
      else                          stageId = 'received';

      /* Check for custom metafield status if set */
      if (order.note && order.note.includes('BUILD_STATUS:')) {
        const match = order.note.match(/BUILD_STATUS:(\w+)/);
        if (match) stageId = match[1];
      }

      this._renderCard({
        orderName:   order.name || `#${order.order_number}`,
        date:        order.created_at ? new Date(order.created_at).toLocaleDateString('en-ZA') : '—',
        total:       order.total_price ? 'R ' + parseFloat(order.total_price).toLocaleString('en-ZA', { minimumFractionDigits: 2 }) : '—',
        stageId,
        items:       order.line_items || []
      });
    }

    _renderDemo(orderNum) {
      /* Demo render for testing — shows "building" stage */
      this._renderCard({
        orderName: `#${orderNum}`,
        date:      new Date().toLocaleDateString('en-ZA'),
        total:     '—',
        stageId:   'building',
        items:     []
      });
    }

    _renderCard({ orderName, date, total, stageId, items }) {
      const stageIndex = BrutechOrderTracker.STAGES.findIndex(s => s.id === stageId);

      /* Header */
      this.querySelector('[data-card-order]').textContent  = orderName;
      this.querySelector('[data-card-date]').textContent   = date;
      this.querySelector('[data-card-total]').textContent  = total;

      const pill = this.querySelector('[data-status-pill]');
      pill.textContent = BrutechOrderTracker.STAGES[Math.max(0, stageIndex)].name;
      pill.className   = `otr__status-pill ${stageId}`;

      /* Stages */
      const stageList = this.querySelector('[data-stage-list]');
      stageList.innerHTML = '';

      BrutechOrderTracker.STAGES.forEach((stage, i) => {
        const state = i < stageIndex ? 'is-done' : i === stageIndex ? 'is-active' : 'is-pending';
        const timeStr = i <= stageIndex ? stage.time : '—';

        const el = document.createElement('div');
        el.className = `otr__stage ${state}`;
        el.innerHTML = `
          <div class="otr__stage-dot">${i < stageIndex ? '✓' : stage.icon}</div>
          <div class="otr__stage-body">
            <div class="otr__stage-name">${stage.name}</div>
            <div class="otr__stage-desc">${stage.desc}</div>
            <div class="otr__stage-time">${timeStr}</div>
            <div class="otr__stage-detail">${stage.detail}</div>
          </div>
        `;
        stageList.appendChild(el);
      });

      /* Items */
      const itemsList = this.querySelector('[data-items-list]');
      itemsList.innerHTML = '';

      if (items.length) {
        items.forEach(item => {
          const el = document.createElement('div');
          el.className = 'otr__item';
          el.innerHTML = `
            <div class="otr__item-img">
              ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '📦'}
            </div>
            <div class="otr__item-info">
              <div class="otr__item-name">${item.title}</div>
              <div class="otr__item-qty">Qty: ${item.quantity}</div>
            </div>
            <div class="otr__item-price">R ${parseFloat(item.price).toLocaleString('en-ZA', { minimumFractionDigits: 2 })}</div>
          `;
          itemsList.appendChild(el);
        });
        this.querySelector('[data-items-section]').style.display = 'block';
      } else {
        this.querySelector('[data-items-section]').style.display = 'none';
      }

      this._card.classList.add('visible');
    }

    _showError(msg) {
      this._error.textContent = '⚠ ' + msg;
      this._error.classList.add('visible');
    }

    _hideError() { this._error.classList.remove('visible'); }

    _setLoading(on) {
      this._loading.classList.toggle('visible', on);
      this._btn.disabled = on;
      this._btn.textContent = on ? 'Searching...' : 'Track Order';
    }
  }

  customElements.define('brutech-order-tracker', BrutechOrderTracker);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-qte-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* One interval for every spotlight on the page. The phase attribute drives
     the colour (amber inside the last day, red inside the last hour), and at
     zero the whole banner leaves, so a stale page never advertises a dead event. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function set(scope, sel, value) {
    var els = scope.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== value) els[i].textContent = value;
    }
  }

  function tick() {
    var list = document.querySelectorAll('.brutech-qs[data-qs-end]');
    for (var i = 0; i < list.length; i++) {
      var sec = list[i];
      var end = parseInt(sec.getAttribute('data-qs-end'), 10);
      if (!end) continue;

      var rem = end - Math.floor(Date.now() / 1000);
      if (rem <= 0) { sec.classList.add('qs-over'); continue; }

      set(sec, '[data-qs-dd]', pad(Math.floor(rem / 86400)));
      set(sec, '[data-qs-hh]', pad(Math.floor((rem % 86400) / 3600)));
      set(sec, '[data-qs-mm]', pad(Math.floor((rem % 3600) / 60)));
      set(sec, '[data-qs-ss]', pad(rem % 60));

      var phase = 'running';
      if (rem < 3600) phase = 'final';
      else if (rem < 86400) phase = 'today';
      if (sec.getAttribute('data-qs-phase') !== phase) sec.setAttribute('data-qs-phase', phase);
    }
  }

  tick();
  setInterval(tick, 1000);
  /* A hidden tab skips its ticks, so it must be right the moment it returns. */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  /* The theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', tick);
})();

/* ── Product slider ──
   The track is a plain scroll-snap scroller, so touch, trackpad and keyboard
   already work with no script. This only drives the arrows, the progress line
   and the count, and warms the images that sit off screen. */
(function () {
  'use strict';

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* aria-disabled, not disabled, so focus is not dropped when an arrow reaches its end. */
  function setDisabled(btn, off) {
    var v = off ? 'true' : 'false';
    if (btn.getAttribute('aria-disabled') !== v) btn.setAttribute('aria-disabled', v);
  }

  function wire(root) {
    var track = root.querySelector('[data-qs-track]');
    var prev = root.querySelector('[data-qs-prev]');
    var next = root.querySelector('[data-qs-next]');
    var thumb = root.querySelector('[data-qs-thumb]');
    var count = root.querySelector('[data-qs-count]');
    if (!track || !prev || !next) return;

    var tiles = track.children;
    var total = tiles.length;
    var frame = 0;
    var thumbW = -1;
    var aim = null;
    var aimUntil = 0;

    /* Distance from one column of cards to the next. One column on a wide screen
       is one card, on a phone it is one stack of rows. */
    function pitch() {
      if (total < 2) return 0;
      var l0 = tiles[0].getBoundingClientRect().left;
      for (var i = 1; i < total; i++) {
        var d = tiles[i].getBoundingClientRect().left - l0;
        if (d > 1) return d;
      }
      return 0;
    }

    function update() {
      frame = 0;
      var cw = track.clientWidth;
      var sw = track.scrollWidth;
      var max = sw - cw;
      var x = track.scrollLeft;

      /* Everything fits, so there is nothing to slide: hide the controls. */
      var scrolls = max > 2;
      if (root.classList.contains('is-static') === scrolls) root.classList.toggle('is-static', !scrolls);
      if (!scrolls) return;

      setDisabled(prev, x <= 2);
      setDisabled(next, x >= max - 2);

      if (thumb && thumb.parentNode) {
        var pw = thumb.parentNode.clientWidth;
        var tw = Math.max(28, Math.round(pw * cw / sw));
        if (tw !== thumbW) { thumb.style.width = tw + 'px'; thumbW = tw; }
        thumb.style.transform = 'translateX(' + Math.round((pw - tw) * (x / max)) + 'px)';
      }

      if (count) {
        var tr = track.getBoundingClientRect();
        var a = -1;
        var b = -1;
        for (var i = 0; i < total; i++) {
          var r = tiles[i].getBoundingClientRect();
          if (r.left >= tr.left - 2 && r.right <= tr.right + 2) {
            if (a < 0) a = i;
            b = i;
          }
        }
        if (a < 0) { a = 0; b = 0; }
        var txt = (a === b ? pad(a + 1) : pad(a + 1) + '-' + pad(b + 1)) + ' / ' + pad(total);
        if (count.textContent !== txt) count.textContent = txt;
      }
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    /* One press moves one page: as many columns as fit on screen (three cards on a
       desktop, one stack of rows on a phone). Pages start at whole multiples of that
       width from the left, and the last page is held back by the end of the track,
       so going forward then back lands on the same pages. Pressing again before the
       glide has finished carries on from where the first press was heading. */
    function go(dir) {
      var p = pitch();
      if (!p) return;
      var page = p * Math.max(1, Math.round(track.clientWidth / p));
      var max = track.scrollWidth - track.clientWidth;
      var now = Date.now();
      var base = (aim !== null && now < aimUntil) ? aim : track.scrollLeft;
      var to = dir > 0
        ? (Math.floor((base + 2) / page) + 1) * page
        : (Math.ceil((base - 2) / page) - 1) * page;
      to = Math.max(0, Math.min(max, to));
      aim = to;
      aimUntil = now + 500;
      if (track.scrollTo) track.scrollTo({ left: to, behavior: reduce.matches ? 'auto' : 'smooth' });
      else track.scrollLeft = to;
    }

    prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
    next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(track);

    /* Images past the first screenful are lazy, and a lazy image inside a
       scroller only starts once it is on screen, so cards would pop in mid
       swipe. Release them when the slider comes near the viewport. */
    function warm() {
      var imgs = track.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { warm(); io.disconnect(); break; }
        }
      }, { rootMargin: '400px 0px' });
      io.observe(root);
    } else {
      warm();
    }

    update();
  }

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-qs-slider]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-qs-ready')) continue;
      list[i].setAttribute('data-qs-ready', '1');
      wire(list[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () { init(); });
  /* The theme editor swaps the section's markup, so the new copy needs wiring. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brutech-quick-time-events"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ════════════════════════════════════════════════════
     1. THE EVENT CLOCK
     One interval for every clock on the page. The phase attribute goes on
     the section, so the CSS can retint everything under it and drop the
     cells that stop mattering as the window closes.
     ════════════════════════════════════════════════════ */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tickClocks() {
    var sections = document.querySelectorAll('.brutech-qte[data-qte-end]');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      var end = parseInt(sec.getAttribute('data-qte-end'), 10);
      if (!end) continue;

      var rem = end - Math.floor(Date.now() / 1000);
      if (rem <= 0) {
        rem = 0;
        if (!sec.classList.contains('qte-over')) {
          sec.classList.add('qte-over');
          /* It becomes real content the moment it is shown, so it stops
             being hidden from screen readers at the same time. */
          var over = sec.querySelector('.q-over');
          if (over) over.setAttribute('aria-hidden', 'false');
        }
      }

      var d = Math.floor(rem / 86400);
      var h = Math.floor((rem % 86400) / 3600);
      var m = Math.floor((rem % 3600) / 60);
      var s = rem % 60;

      set(sec, '[data-qte-dd]', pad(d));
      set(sec, '[data-qte-hh]', pad(h));
      set(sec, '[data-qte-mm]', pad(m));
      set(sec, '[data-qte-ss]', pad(s));

      /* Almost nothing happens in the middle of an event and everything
         happens at the end, so the clock changes shape as it closes. */
      var phase = 'running';
      if (rem <= 0) { phase = 'over'; }
      else if (rem < 3600) { phase = 'final'; }
      else if (rem < 86400) { phase = 'today'; }
      sec.setAttribute('data-qte-phase', phase);
    }
  }

  function set(scope, sel, value) {
    var els = scope.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== value) els[i].textContent = value;
    }
  }

  tickClocks();
  setInterval(tickClocks, 1000);
  /* A tab nobody is looking at does not need a per second repaint, but it
     does need to be correct the instant it comes back. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tickClocks();
  });

  /* ════════════════════════════════════════════════════
     2. THE TRAINING SIM
     A quick time event in its smallest form. It changes no price and
     unlocks nothing, it just lets someone feel the mechanic once so the
     rest of the page stops needing a paragraph of explanation.
     Runs only while it is on screen and the tab is visible.
     ════════════════════════════════════════════════════ */
  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { reduced = false; }

  var START_SCALE = 2.6;
  var END_SCALE = 1.0;
  var GRACE = 180;      /* ms you are still allowed to be late by */
  var HOLD = 900;       /* ms a result stays on screen before the next run */

  function buildSim(root) {
    var dur = parseInt(root.getAttribute('data-q-dur'), 10) || 2200;
    var band = parseInt(root.getAttribute('data-q-band'), 10) || 260;

    /* A pool of keys, one drawn per round. Non alphanumerics are stripped so
       a stray comma or space in the setting cannot become a key nobody has. */
    var keys = (root.getAttribute('data-q-keys') || 'e')
      .toLowerCase().replace(/[^a-z0-9]/g, '').split('');
    if (!keys.length) keys = ['e'];
    var key = keys[0];

    var ring = root.querySelector('[data-q-ring]');
    var cue = root.querySelector('[data-q-cue]');
    var read = root.querySelector('[data-q-read]');
    var btn = root.querySelector('[data-q-hit]');
    var elAtt = root.querySelector('[data-q-att]');
    var elHits = root.querySelector('[data-q-hits]');
    var elBest = root.querySelector('[data-q-best]');
    var cap = root.querySelector('[data-q-cap]');

    var started = 0;
    var running = false;
    var resolved = false;
    var visible = false;
    var raf = 0;
    var attempts = 0;
    var hits = 0;
    var best = null;
    if (reduced) root.setAttribute('data-q-reduced', 'true');

    /* Never the same key twice running, otherwise the pool stops mattering
       on a short list. Guarded on length so a single key cannot spin here. */
    function drawKey() {
      if (keys.length < 2) { key = keys[0]; return; }
      var next = key;
      while (next === key) { next = keys[Math.floor(Math.random() * keys.length)]; }
      key = next;
    }

    function showKey() {
      var up = key.toUpperCase();
      if (cap) {
        cap.textContent = up;
        /* Retrigger the swap animation without a reflow hack. */
        cap.removeAttribute('data-q-swap');
        void cap.offsetWidth;
        cap.setAttribute('data-q-swap', 'true');
      }
      if (btn) btn.setAttribute('aria-label', 'Press ' + up);
    }

    function start() {
      drawKey();
      showKey();
      started = performance.now();
      running = true;
      resolved = false;
      root.setAttribute('data-q-state', 'running');
      if (read) read.textContent = 'Press ' + key.toUpperCase() + ' on the marker';
      loop();
    }

    function stop() {
      running = false;
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }

    function loop() {
      if (!running) return;
      var t = performance.now() - started;

      if (!reduced && ring) {
        var p = t / dur;
        if (p > 1) p = 1;
        var scale = START_SCALE - (START_SCALE - END_SCALE) * p;
        ring.style.transform = 'scale(' + scale.toFixed(4) + ')';
      }

      if (reduced && cue) {
        var left = dur - t;
        var label = '3';
        if (left <= band) label = 'NOW';
        else if (left < dur * 0.34) label = '1';
        else if (left < dur * 0.67) label = '2';
        if (cue.textContent !== label) cue.textContent = label;
      }

      if (!resolved && t > dur + GRACE) {
        resolve('late', t - dur);
        return;
      }
      raf = requestAnimationFrame(loop);
    }

    function attempt() {
      if (!running || resolved) return;
      var delta = (performance.now() - started) - dur;
      if (delta < -band) { resolve('early', delta); return; }
      resolve('hit', delta);
    }

    function resolve(state, delta) {
      resolved = true;
      stop();
      attempts++;
      root.setAttribute('data-q-state', state);

      var off = Math.round(Math.abs(delta));
      if (state === 'hit') {
        hits++;
        if (best === null || off < best) best = off;
        if (read) read.textContent = off < 60 ? 'Perfect, ' + off + ' ms off' : 'Claimed, ' + off + ' ms off';
      } else if (state === 'early') {
        if (read) read.textContent = 'Too early by ' + off + ' ms';
      } else {
        if (read) read.textContent = 'Missed it. That is the whole idea.';
      }

      if (elAtt) elAtt.textContent = String(attempts);
      if (elHits) elHits.textContent = String(hits);
      if (elBest) elBest.textContent = best === null ? '--' : best + ' ms';
      if (reduced && cue) cue.textContent = state === 'hit' ? 'HIT' : 'MISS';

      setTimeout(function () {
        root.setAttribute('data-q-state', 'idle');
        if (!visible || document.hidden || !root.isConnected) return;
        start();
      }, HOLD);
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        attempt();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!root.isConnected) return;
      if (!visible || !running) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if ((e.key || '').toLowerCase() !== key) return;

      var t = e.target;
      if (t && t.closest && t.closest('input,textarea,select,[contenteditable="true"]')) return;
      e.preventDefault();
      attempt();
    });

    /* Only run while somebody is actually looking at it. */
    function setVisible(v) {
      if (v === visible) return;
      visible = v;
      if (v && !document.hidden) {
        if (!running) start();
      } else {
        stop();
        if (ring) ring.style.transform = 'scale(' + START_SCALE + ')';
        root.setAttribute('data-q-state', 'idle');
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          setVisible(entries[i].isIntersecting);
        }
      }, { threshold: 0.35 });
      io.observe(root);
    } else {
      setVisible(true);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); }
      else if (visible && !running) { start(); }
    });
  }

  function initSims() {
    var sims = document.querySelectorAll('[data-q-sim]');
    for (var i = 0; i < sims.length; i++) {
      if (sims[i].getAttribute('data-q-ready') === 'true') continue;
      sims[i].setAttribute('data-q-ready', 'true');
      buildSim(sims[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSims);
  } else {
    initSims();
  }

  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector && evt.target.querySelector('.brutech-qte')) {
      initSims();
      tickClocks();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
